module.exports = __webpack_public_path__ + "img/cb9-l-011.33b6532b.gif";